// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

import PhoneNumberData from '../../types/PhoneNumberData';

import { format0 } from '../../constants';

/** Antigua & Barbuda */
const AG: PhoneNumberData = [1, 'AG', 10, format0, /^(?:268)/];

export default AG;
